function taxInitializer() {
  // 2021 tax rates provided by David
  
  const fedTaxRates = [
    { max: 12421, tax: 0 },
    { max: 49020, tax: 0.15 },
    { max: 98040, tax: 0.205 },
    { max: 151978, tax: 0.26 },
    { max: 216511, tax: 0.29 },
    { max: Number.MAX_VALUE, tax: 0.33 },
  ];

  const provTaxRates = {
    AB: [
      { max: 19369, tax: 0 },
      { max: 131220, tax: 0.1 },
      { max: 157464, tax: 0.12 },
      { max: 209952, tax: 0.13 },
      { max: 314928, tax: 0.14 },
      { max: Number.MAX_VALUE, tax: 0.15 },
    ],
    BC: [
      { max: 11070, tax: 0 },
      { max: 42184, tax: 0.0506 },
      { max: 84369, tax: 0.0770 },
      { max: 96866, tax: 0.105 },
      { max: 117623, tax: 0.1229 },
      { max: 159483, tax: 0.1470 },
      { max: 222420, tax: 0.1680 },
      { max: Number.MAX_VALUE, tax: 0.2050 },
    ],
    MB: [
      { max: 9936, tax: 0 },
      { max: 33723, tax: 0.108 },
      { max: 72885, tax: 0.1275 },
      { max: Number.MAX_VALUE, tax: 0.1740 },
    ],
    NB: [
      { max: 10564, tax: 0 },
      { max: 43835, tax: 0.0968 },
      { max: 87671, tax: 0.1482 },
      { max: 142534, tax: 0.1652 },
      { max: 162383, tax: 0.1784 },
      { max: Number.MAX_VALUE, tax: 0.203 },
    ],
    NL: [
      { max: 9536, tax: 0 },
      { max: 38081, tax: 0.087 },
      { max: 76161, tax: 0.145 },
      { max: 135973, tax: 0.158 },
      { max: 190363, tax: 0.173 },
      { max: Number.MAX_VALUE, tax: 0.183 },
    ],
    NT: [
      { max: 15243, tax: 0 },
      { max: 44396, tax: 0.059 },
      { max: 88796, tax: 0.086 },
      { max: 144362, tax: 0.122 },
      { max: Number.MAX_VALUE, tax: 0.1405 },
    ],
    NS: [
      { max: 8481, tax: 0 },
      { max: 29590, tax: 0.0879 },
      { max: 59180, tax: 0.1495 },
      { max: 93000, tax: 0.1667 },
      { max: 150000, tax: 0.175 },
      { max: Number.MAX_VALUE, tax: 0.21 },
    ],
    NU: [
      { max: 16467, tax: 0 },
      { max: 46740, tax: 0.04 },
      { max: 93480, tax: 0.07 },
      { max: 151978, tax: 0.09 },
      { max: Number.MAX_VALUE, tax: 0.115 },
    ],
    ON: [
      { max: 10880, tax: 0 },
      { max: 45142, tax: 0.0505 },
      { max: 90287, tax: 0.0915 },
      { max: 150000, tax: 0.1116 },
      { max: 220000, tax: 0.1216 },
      { max: Number.MAX_VALUE, tax: 0.1316 },
    ],
    PE: [
      { max: 10500, tax: 0 },
      { max: 31984, tax: 0.098 },
      { max: 63969, tax: 0.138 },
      { max: Number.MAX_VALUE, tax: 0.167 },
    ],
    QC: [
      { max: 15728, tax: 0 },
      { max: 45105, tax: 0.15 },
      { max: 90200, tax: 0.2 },
      { max: 109755, tax: 0.24 },
      { max: Number.MAX_VALUE, tax: 0.2575 },
    ],
    SK: [
      { max: 16225, tax: 0 },
      { max: 45677, tax: 0.105 },
      { max: 130506, tax: 0.125 },
      { max: Number.MAX_VALUE, tax: 0.145 },
    ],
    YT: [
      { max: 13808, tax: 0 },
      { max: 49020, tax: 0.064 },
      { max: 98040, tax: 0.09 },
      { max: 151978, tax: 0.109 },
      { max: 500000, tax: 0.128 },
      { max: Number.MAX_VALUE, tax: 0.15 },
    ],
  };

  const noProvinceError = 'TaxService: No province specified.';

  return {
    getTaxTable(grossIncome, brackets) {
      let min = 0;
      const results = [];
      _.forEach(brackets, (bracket) => {
        let taxAmount;

        if (grossIncome < min) {
          return false;
        }

        if (grossIncome <= bracket.max) {
          taxAmount = Math.max(grossIncome - min, 0) * bracket.tax;
        } else {
          taxAmount = (bracket.max - min) * bracket.tax;
        }

        const max = bracket.max === Number.MAX_VALUE ? null : bracket.max;
        const result = {
          max,
          min,
          rate: bracket.tax,
          amount: taxAmount,
        };

        results.push(result);
        min = bracket.max;

        return true;
      });

      return results;
    },
    getFederalTaxTable(grossIncome) {
      return this.getTaxTable(grossIncome || 0, fedTaxRates);
    },
    getProvincialTaxTable(grossIncome, province) {
      if (province) {
        const brackets = provTaxRates[province];
        return this.getTaxTable(grossIncome, brackets);
      }
      throw noProvinceError;
    },
    getFederalTaxAmount(grossIncome) {
      return _.sumBy(this.getFederalTaxTable(grossIncome), 'amount');
    },
    getProvTaxAmount(grossIncome, province) {
      return _.sumBy(this.getProvincialTaxTable(grossIncome, province), 'amount');
    },
    getNetIncome(grossIncome, province) {
      return grossIncome - this.getTaxes(grossIncome, province);
    },
    getTaxes(grossIncome, province) {
      const fedTaxAmount = this.getFederalTaxAmount(grossIncome);
      const provTaxAmount = this.getProvTaxAmount(grossIncome, province);
      return fedTaxAmount + provTaxAmount;
    },
    getAverageTaxRate(grossIncome, province) {
      if (grossIncome === 0) {
        return 0;
      } else if (!grossIncome) {
        return undefined;
      }

      const fedTaxAmount = this.getFederalTaxAmount(grossIncome);
      const provTaxAmount = this.getProvTaxAmount(grossIncome, province);
      return (fedTaxAmount + provTaxAmount) / grossIncome;
    },
    getMarginalTaxRate(grossIncome, province) {
      if (province) {
        if (grossIncome === null) {
          return undefined;
        }

        const { tax: fedMarginalTR } = _.find(fedTaxRates, bracket => grossIncome <= bracket.max);

        const taxRatesForProvince = provTaxRates[province];
        const provMarginalTR = taxRatesForProvince ?
          _.find(taxRatesForProvince, bracket => grossIncome <= bracket.max)
            .tax
          : 0;

        return provMarginalTR + fedMarginalTR;
      }
      throw noProvinceError;
    },
    getFederalTaxRates() {
      return angular.copy(fedTaxRates);
    },
    getProvincialTaxRates(province) {
      if (province != null) { return angular.copy(provTaxRates[province]); }
      return angular.copy(provTaxRates);
    },
    getGrossIncomeFromNet(netIncome, province) {
      if (province) {
        const values = _(fedTaxRates)
          .union(provTaxRates[province])
          .map(({ max }) => max)
          .uniq()
          .sortBy()
          .value();

        let taxPaid = 0;
        let lastNetValue = 0;
        let bracketRate;

        _.forEach(values, (value) => {
          const netValue = this.getNetIncome(value, province);
          if (netValue <= netIncome) {
            taxPaid = value - netValue;
            lastNetValue = netValue;
            return true;
          }

          bracketRate = this.getMarginalTaxRate(value, province);
          return false;
        });

        return lastNetValue + taxPaid + ((netIncome - lastNetValue) / (1 - bracketRate));
      }

      throw noProvinceError;
    },
    getTaxDeduction(grossIncome, deduction, province) {
      const before = this.getTaxes(grossIncome, province);
      const after = this.getTaxes(grossIncome - deduction, province);
      return before - after;
    },
  };
}

angular.module('wbServices').service('tax', [taxInitializer]);

export default taxInitializer;
